import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
    id: 'HOTEL_RATING',
    analyticsName: (k) => `Hotel standard ${k}`,
    queryKey: 'f_rating',
    type: FILTER_TYPES.SEGMENTS,
    caId: 'rating',
    decorateFinalState: (filterState, filterTree) => {
        // NB: We want to display ALL values even if we do not have any matches
        // NB: This is not an ideal solution, but when this was built we had to make stuff dynamic.
        for (let i = 2; i < 6; ++i) {
            filterState.values[i] = filterState.values[i] || {
                name: `STARZ ${i}`,
                value: false
            };

            filterTree[i] = filterTree[i] || [];
        }
    },
    bucketify: (hotel) => {
        const hotelRating = hotel?.hotelRating || 0;

        if (!hotelRating) {
            return false;
        }

        // NB: Rating is measured in half steps (3 = 1 heart and a "+")

        return {
            bucketId: Math.floor(hotelRating / 2),
            bucketName: 'STARZ ' + Math.floor(hotelRating / 2)
        };
    },
    toQuery: ({ value, optionId } = {}, storeValues) => {
        const values = [];

        storeValues && storeValues.forEach((valueObject, storeOptionId) => {
            if (optionId !== storeOptionId && valueObject?.value) {
                values.push(storeOptionId);
            }
        });

        if (value) {
            values.push(optionId);
        }

        return values.length ? values.join('|') : undefined;
    },
    fromQuery: (rawQueryValue) => {
        if (!rawQueryValue || typeof rawQueryValue !== 'string') {
            return false;
        }

        const values = rawQueryValue.split('|');

        const res = {};
        values && values.forEach((value) => {
            res[value] = true;
        });

        return res;
    }
}));
